/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aac44878318d6742bb2bf31e401f4a97>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/subtasks';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/subtask/24';

/**
 * __24px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Subtask24Icon = function Subtask24Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  if (fg('icon-object-migration')) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: NewIcon,
      appearance: "blueBold",
      size: "24",
      label: label,
      testId: testId,
      LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
        label: label,
        testId: testId
      })
    });
  } else {
    return /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    });
  }
};
Subtask24Icon.displayName = 'Subtask24Icon';
export default Subtask24Icon;